import {
  EMPTY_LIBRARY_FILTERS,
  LibraryFilterState,
} from "./libraryTypes";

export type ProductLibrarySortBy =
  | "name"
  | "priceLow"
  | "priceHigh"
  | "updatedAt";

export type ProductLibraryCommunitySort = "NAME" | "RECENT";

/**
 * In-memory session for the 3D Product Library panel.
 * Survives close/reopen within the same page session (no localStorage).
 */
export type ProductLibrarySessionState = {
  search: string;
  filters: LibraryFilterState;
  sortBy: ProductLibrarySortBy;
  communitySort: ProductLibraryCommunitySort;
  page: number;
};

const session: ProductLibrarySessionState = {
  search: "",
  filters: { ...EMPTY_LIBRARY_FILTERS },
  sortBy: "name",
  communitySort: "RECENT",
  page: 0,
};

export const getProductLibrarySession = (): ProductLibrarySessionState =>
  session;

export const patchProductLibrarySession = (
  patch: Partial<ProductLibrarySessionState>,
): void => {
  if (patch.search !== undefined) session.search = patch.search;
  if (patch.filters !== undefined) {
    session.filters = { ...patch.filters };
  }
  if (patch.sortBy !== undefined) session.sortBy = patch.sortBy;
  if (patch.communitySort !== undefined) {
    session.communitySort = patch.communitySort;
  }
  if (patch.page !== undefined) session.page = patch.page;
};

/** Test helper — resets session between unit tests. */
export const resetProductLibrarySession = (): void => {
  session.search = "";
  session.filters = { ...EMPTY_LIBRARY_FILTERS };
  session.sortBy = "name";
  session.communitySort = "RECENT";
  session.page = 0;
};
